import React from 'react'
import * as Style from './FileDownload.module.scss'
import Button from "../UI/button/Button"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { saveAs } from "file-saver"

const FileDownload = ({file}) => {
  const saveFile = () => {
    saveAs(
      `${file.url}`,
      `${file.name}`
    );
  };

  return (
    <div className={Style.wrapper}>
        <div className={Style.filename}>{file.name}</div>
        <Button style={Style.button} buttonHandler={saveFile}>
            Download
            {/* <GatsbyImage image={getImage(button.button_arrow.localFile)} alt={button.button_title}/> */}
        </Button>
    </div>
  )
}

export default FileDownload